import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { PillButton } from '../PillButton';
import { SiblingFigure } from '../characters/SiblingFigure';
import { getSibling } from '../../data/siblings';
import type { SiblingRole } from '../../types/snak';
interface ResponseScreenProps {
  role: SiblingRole;
  onNext: () => void;
}
export function ResponseScreen({
  role,
  onNext
}: ResponseScreenProps) {
  const sibling = getSibling(role);
  const [ack, setAck] = useState<string | null>(null);
  const answer = (line: string) => {
    if (ack) return;
    setAck(line);
    window.setTimeout(onNext, 1250);
  };
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-420" data-mp="2bznfvlgxsold">
      <Reveal data-id="element-421" data-mp="2bz3utvvzpk34">
        <div className="relative flex items-center justify-center overflow-hidden rounded-[28px] px-4 py-6" style={{
        backgroundColor: sibling.surface
      }} data-id="element-422" data-mp="2c1q2rwmsm1lv">
          <motion.div initial={{
          y: 20,
          scale: 0.9,
          rotate: -3
        }} animate={{
          y: 0,
          scale: 1,
          rotate: 0
        }} transition={{
          type: 'spring',
          stiffness: 260,
          damping: 18,
          delay: 0.1
        }} data-id="element-423" data-mp="2l0lbpgh81psv">
            <SiblingFigure role={role} className="h-[168px] w-[168px]" data-id="element-424" data-mp="1kqvj4o63z097" />
          </motion.div>
          <span className="absolute left-4 top-4 rounded-full bg-background px-3 py-1 font-body text-[10px] uppercase tracking-[0.18em] text-white" data-id="element-425" data-mp="1ksq3a09k2oc8">
            {sibling.label}
          </span>
        </div>
      </Reveal>

      <Reveal delay={0.18} data-id="element-426" data-mp="28gprasfhg0n4">
        <h2 className="mt-6 font-heading text-[30px] leading-[1.05] tracking-[-0.02em] text-background" data-id="element-427" data-mp="28hiwhoysmi35">
          {sibling.responseTitle}
        </h2>
      </Reveal>
      <Reveal delay={0.26} data-id="element-428" data-mp="1yqxv5trqizgj">
        <p className="mt-3 font-body text-[15px] leading-relaxed text-[rgba(1,51,43,0.72)]" data-id="element-429" data-mp="1ypmwg8d5chwa">
          {sibling.responseBody}
        </p>
      </Reveal>

      <Reveal delay={0.36} className="mt-7" data-id="element-430" data-mp="2rfbwoji18dwu">
        <p className="font-heading text-[17px] text-background" data-id="element-431" data-mp="2reaiw79mtdbf">Sound familiar?</p>
        <div className="mt-3 flex flex-col gap-2.5" data-id="element-432" data-mp="phjjmkd905o6">
          <PillButton full onClick={() => answer('Noted. 😌')} data-id="element-433" data-mp="pjw9djp8zkbs">
            Maybe a little 😏
          </PillButton>
          <PillButton full variant="outline" onClick={() => answer('Fair enough.')} data-id="element-434" data-mp="frzyt95z61qo">
            Not even close
          </PillButton>
        </div>
      </Reveal>

      <AnimatePresence data-id="element-435" data-mp="kpi8x2vqan09">
        {ack && <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} className="mt-4 text-center font-body text-[13px] text-[rgba(1,51,43,0.55)]" data-id="element-436" data-mp="5u2bqozuqazn">
            {ack} Hold that thought.
          </motion.p>}
      </AnimatePresence>
    </div>;
}